import axios, { type AxiosRequestConfig, type AxiosResponse } from "axios";

/**
 * Form-urlencoded POST matching legacy `jQuery.post` for `Request.Form` endpoints.
 * Plain `axios.post` would send JSON and those fields would be missing.
 *
 * Top-level `null`/`undefined` become `""` so keys stay on the wire like jQuery.
 */
export function postUrlEncoded<T = unknown>(
	url: string,
	data: Record<string, unknown>,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<T>> {
	return axios.post<T>(url, normalizeNullish(data), {
		...config,
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
			...config?.headers,
		},
	});
}

function normalizeNullish(data: Record<string, unknown>): Record<string, unknown> {
	return Object.fromEntries(
		Object.entries(data).map(([key, value]) => [key, value ?? ""]),
	);
}
